import { Component, Input } from '@angular/core';
import { CarDTO } from '../../../../../interfaces/carDTO';

@Component({
  selector: 'app-order-cargo-details-view',
  templateUrl: './order-cargo-details-view.component.html',
})
export class OrderCargoDetailsViewComponent {
  @Input() cars: CarDTO[] = [];
}
